import type {
  FormSchema,
  PublicBrandingLogoSize,
  PublicBrandingSettings,
  ResolvedPublicBranding,
} from "./schema_types";

export const DEFAULT_FORM_FILL_ACCENT = "#008070";
export const DEFAULT_PUBLIC_BRANDING_LOGO_SIZE: PublicBrandingLogoSize = "m";

export function getPublicBrandingSettings(
  schema: FormSchema,
): PublicBrandingSettings | undefined {
  return schema.settings?.publicBranding;
}

export function isPublicBrandingActive(
  branding: PublicBrandingSettings | undefined,
): boolean {
  return branding?.enabled === true;
}

export function resolveFormFillAccentColor(
  branding: PublicBrandingSettings | undefined,
): string {
  const raw: string | undefined = branding?.accent_color?.trim();
  if (raw && /^#[0-9a-fA-F]{6}$/.test(raw)) return raw;
  return DEFAULT_FORM_FILL_ACCENT;
}

export function resolvePublicBrandingLogoSize(
  branding: PublicBrandingSettings | undefined,
): PublicBrandingLogoSize {
  const size: PublicBrandingLogoSize | undefined = branding?.logo_size;
  if (size === "s" || size === "m" || size === "l") return size;
  return DEFAULT_PUBLIC_BRANDING_LOGO_SIZE;
}

export function buildResolvedPublicBranding(
  schema: FormSchema,
  logoUrl: string | null,
): ResolvedPublicBranding {
  const branding = getPublicBrandingSettings(schema);
  return {
    enabled: isPublicBrandingActive(branding),
    accent_color: resolveFormFillAccentColor(branding),
    logo_url: isPublicBrandingActive(branding) ? logoUrl : null,
    logo_size: resolvePublicBrandingLogoSize(branding),
  };
}
